import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import { AddTextField } from "./container/components/AddTextField";
import ImageInput from "./ImageInput";
import { FolderName } from "../../../api/shared/uploadService";
import { CreateArtifactContext } from "../../../context/CreateArtifactContext";

interface EditLayoutTableProps {
  isOpen: boolean;
  linkTitle?: string;
  searchURL?: string;
  linkPhotoUrl?: string;
  onClose: () => void;
  onSave: (title: string, imageLPath: string) => void;
  onChange?: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const EditLayoutTable = ({ isOpen, linkTitle, searchURL, linkPhotoUrl, onClose, onSave, onChange }: EditLayoutTableProps) => {
  const { contentData, artifactId, updateContentData, loading, saveData, isEditable } = useContext(CreateArtifactContext);
  const [iteamTitle, setIteamTitle] = useState(linkTitle || "");
  const [siteURL, setSiteURL] = useState(searchURL || "");
  const [photoUrl, setPhotoUrl] = useState(linkPhotoUrl || "");
  const [originalTitle, setOriginalTitle] = useState(linkTitle || "");
  const [isValidInput, setIsValidInput] = useState(false);

  useEffect(() => {
    setIteamTitle(linkTitle || "");
    setSiteURL(searchURL || "");
    setPhotoUrl(linkPhotoUrl || "");
    setOriginalTitle(linkTitle || "");
  }, [linkTitle, searchURL, linkPhotoUrl]);

  useEffect(() => {
    setIsValidInput(siteURL.length >= 3 && iteamTitle.length >= 3 && photoUrl != null);
  }, [siteURL, iteamTitle, photoUrl]);

  const isEdited = iteamTitle !== linkTitle || siteURL !== searchURL || photoUrl !== linkPhotoUrl;

  if (!isOpen) return null;

  const handleImageChange = (index: number, fileUrl: string | null) => {
    setPhotoUrl(fileUrl ?? "");
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
      <div className="p-6 bg-white rounded-lg shadow-lg w-96">
        <div className="relative w-full min-w-[200px] mb-2">
          <div className="flex items-center space-x-2">
            <span className="content_title">Edit List Item</span>
          </div>
          <p className="notes-class-content">Update the item name or Image.</p>
          <div className="flex input-class mb-[15px] bg-slate-500">
            <input
              type="text"
              name="listName"
              id="listName"
              className="bg-gray-400 input-text"
              placeholder="URL"
              readOnly
              maxLength={300}
              value={siteURL}
            />
          </div>
          <AddTextField
            placeholder={"Link Name"}
            charAllowed={150}
            value={iteamTitle ?? ""}
            onChange={async e => {
              setIteamTitle(e.target.value);
            }}
            disabled={!isEditable}
          />
          <div className="flex justify-center items-center p-[30px]">
            <ImageInput
              key={0}
              index={4}
              onFileChange={handleImageChange}
              maxFileSize={5}
              imageUrl={photoUrl ?? ""}
              folder={FolderName.content}
              docId={artifactId ?? ""}
            />
          </div>

          <div className="flex justify-center w-full gap-10 mt-[15px]">
            <button
              type="submit"
              onClick={() => onSave(iteamTitle, photoUrl)}
              disabled={!isEdited}
              className={
                isEdited
                  ? "bg-black cursor-pointer text-white px-3 py-2 text-sm font-normal text-center p-1 border-2 rounded-lg w-1/2"
                  : "bg-gray-400 disabled-link px-3 py-2 text-sm font-normal text-center p-1 border-2 rounded-lg w-1/2"
              }
            >
              Done
            </button>
            <button
              type="button"
              onClick={onClose}
              className={
                "flex bg-white cursor-pointer items-center justify-center px-3 py-2 text-sm font-normal text-center p-1 border-2 border-black text-black rounded-lg w-1/2"
              }
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
